import { getLocalStorage } from "../../services/localSessionService";

export const baseApiUrl: any = localStorage.getItem("baseApiUrl") || "http://localhost:8000";

const getMethod = async (pageUrl: any) => {
    const accessToken = getLocalStorage("accessToken") || "erp-system-manufacture";
    const headers =  {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${accessToken}`
    };
    const userInfo = await fetch(baseApiUrl + pageUrl, {
        method: "GET", 
        headers : headers
    });
    return userInfo;
}
const postMethod = async (pageUrl: any, data: any) => {
    const accessToken = getLocalStorage("accessToken") || "erp-system-manufacture";
    data.headers =  {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${accessToken}`
    };
    const userInfo = await fetch(baseApiUrl + pageUrl, data);
    return userInfo;
}

const uploadMethod = async (pageUrl: any, data: any) => {
    const accessToken = getLocalStorage("accessToken") || "erp-system-manufacture";
    data.headers =  {
        Accept: "*/*",
        "Authorization": `Bearer ${accessToken}`
    };
    const userInfo = await fetch(baseApiUrl + pageUrl, data);
    return userInfo;
}

const uploadUrlMethod = async (pageUrl: any, data: any) => {
    const accessToken = getLocalStorage("accessToken") || "erp-system-manufacture";
    data.headers =  {
        Accept: "*/*",
        "Authorization": `Bearer ${accessToken}`
    };
    const userInfo = await fetch(pageUrl, data);
    return userInfo;
}

export {getMethod, postMethod, uploadMethod, uploadUrlMethod};